import axios from "axios";

export default {
  get() {
    return axios({ url: "/cart", method: "GET" });
  },
  update(cart) {
    return axios({ url: "/cart", data: cart, method: "PUT" });
  }
};
